import {setStoredAuthToken} from "shared/utils/authSession";
import React, {useEffect, useState} from "react";
import "./GoogleLogin.css";
import googleIcon from "assets/google-icon.png";
import {useNavigate} from "react-router-dom";
import {API_URL, IS_JAMPA} from "shared/api/client";
import logoHK from "assets/logo-hk.svg";
import logoJampa from "assets/logo-jampa.svg";
import {
    decodeAuthTokenClaims,
    getAuthenticatedHomePath,
    isUserAccountsSession,
} from "shared/utils/userAccountSession";
import {createBrowserGoogleLoginUrl, createLocalStageGoogleLoginUrl, usesLocalStageGoogleAuth} from "./localStageGoogleAuth";


const GoogleLogin: React.FC = () => {
    const navigate = useNavigate();
    const [startingLogin, setStartingLogin] = useState(false);
    const [loginError, setLoginError] = useState<string | null>(null);

    const handleGoogleLogin = async () => {
        if (startingLogin) return;
        setStartingLogin(true);
        setLoginError(null);
        try {
            const loginUrl = usesLocalStageGoogleAuth(API_URL)
                ? await createLocalStageGoogleLoginUrl(API_URL)
                : await createBrowserGoogleLoginUrl(API_URL);
            window.location.assign(loginUrl);
        } catch (error) {
            setLoginError(error instanceof Error ? error.message : "לא ניתן להתחיל את ההתחברות. יש לנסות שוב.");
            setStartingLogin(false);
        }
    };

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (!token) return;

        try {
            const decoded = decodeAuthTokenClaims(token);
            if (!decoded) {
                setStoredAuthToken(null);
                return;
            }
            if (!isUserAccountsSession(decoded)) {
                setStoredAuthToken(null);
                setLoginError("יש להתחבר מחדש כדי להיכנס לסביבת העבודה.");
                return;
            }
            const now = Math.floor(Date.now() / 1000);
            const valid = (decoded.exp ?? 0) - 300 > now;
            if (valid) {
                navigate(getAuthenticatedHomePath(decoded), {replace: true});
            }
        } catch {
            setStoredAuthToken(null);
        }
    }, [navigate]);

    return (
        <div className={IS_JAMPA ? 'login-container-jampa' : 'login-container'}>
            <div className="login-card">
                <img src={IS_JAMPA ? logoJampa : logoHK} alt="חזות קריספין" className="login-logo"/>
                <div className="border-line"></div>
                <h2 className="login-title">כניסה לחשבון</h2>
                <button type="button" className="google-login" onClick={handleGoogleLogin} disabled={startingLogin}>
                    <img src={googleIcon} alt="Google" className="google-icon"/>
                    {startingLogin ? "מעבר ל־Google…" : "כניסה באמצעות גוגל"}
                </button>
                {loginError && <p className="login-error" role="alert">{loginError}</p>}
                {/*<a href="https://www.hak.co.il/privacy" target="_blank" rel="noopener noreferrer"*/}
                {/*   className="privacy-link">*/}
                {/*    מדיניות פרטיות*/}
                {/*</a>*/}
            </div>
        </div>
    );
};

export default GoogleLogin;
